import { FC, useCallback, useMemo } from 'react';
import { Link } from '@remix-run/react';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';
import { useTranslation } from 'react-i18next';
import useReflowClick from '~/utils/use-reflow-click';
import { useActiveToArticle } from '~/utils/active/use-active-to-article';
import { kepQueryFormat } from 'shared/utils/format/kep-formatter';
import { SEOKeywordsItem } from '~/components/seo-keywords-item';
import { TArticleDetail } from 'shared/models';

import './style.scss';

interface IArticleSARProps {
  currentArticle: TArticleDetail;
  positionPrefix?: ClickPositionPrefix;
}

export const SAR: FC<IArticleSARProps> = (props) => {
  const { t } = useTranslation();
  const { currentArticle, positionPrefix = ClickPositionPrefix.none } = props;
  const { relatedQuery = '', articleRegion } = currentArticle;
  const activeToArticle = useActiveToArticle(currentArticle);

  const href = useMemo(() => `/discover/${kepQueryFormat(relatedQuery)}?region=${articleRegion}`, [relatedQuery]);

  const sarObservedRef = useViewTracking<HTMLAnchorElement>({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: positionPrefix + ClickPosition.main_sar,
        group_id: currentArticle.groupId,
      });
    }, []),
  });

  const handleSarClick = useReflowClick(
    {
      reflowBehavior: () => {
        activeToArticle([positionPrefix, ClickPosition.main_sar]);
      },
      clickEvent: () => ({
        current_position: positionPrefix + ClickPosition.main_sar,
        page_click_id: kepQueryFormat(relatedQuery) || '',
      }),
    },
    [activeToArticle],
  );

  if (!relatedQuery) {
    return null;
  }

  return (
    <object>
      <Link to={href} onClick={handleSarClick} className="sar" ref={sarObservedRef}>
        <div className="sar-container">
          <div className="search-icon" />
          <div className="search-text">{t('search_sar_query')} ·</div>
          <div className="search-query">
            <SEOKeywordsItem keyword={relatedQuery} />
          </div>
          <div className="arrow-icon" />
        </div>
      </Link>
    </object>
  );
};
